import { useConversationMessageCacheHandler } from "#features/conversations/hooks/useConversationMessageCacheHandler.ts";
import { useAiApiClient } from "#lib/AiApiClient.ts";
import { AiMutationKeys } from "#lib/AiQueryKeys.ts";
import type { UpdateConversationMessageRatingCommand } from "#types/types.ts";
import { useMutation } from "@tanstack/react-query";

export const useUpdateConversationMessageRatingMutation = () => {
    const { updateConversationMessageRating } = useAiApiClient();
    const { updateMessage } = useConversationMessageCacheHandler();

    return useMutation({
        mutationKey: AiMutationKeys.UpdateConversationMessageRating(),
        onMutate: async (payload: UpdateConversationMessageRatingCommand) => {
            const { conversationId, conversationMessageId, rating } = payload;

            updateMessage(conversationId, conversationMessageId, message => ({
                ...message,
                rating,
                ratingExplanation: null
            }));
        },
        mutationFn: async (payload: UpdateConversationMessageRatingCommand) => {
            await updateConversationMessageRating(payload);
        },
        onError: (_, { conversationId, conversationMessageId, rating }) => {
            updateMessage(conversationId, conversationMessageId, message => ({
                ...message,
                rating: rating ? undefined : rating // revert to either no rating or previous rating value
            }));
        }
    });
};
